<template>
  <div>
    <van-nav-bar class="head bg-color-theme" title="区域和位置" fixed ref="head" v-if="deviceType !== 'weixin'">
      <template #title>
        <div style="color: #FFFFFF;font-size: 14px;">健康问卷调查</div>
      </template>
    </van-nav-bar>

    <div v-show="loading" class="loading">
      <van-loading type="spinner" vertical>数据加载中...</van-loading>
    </div>

    <div class="area" v-show="!loading">
      <div class="title">请选择区域和位置</div>
      <div class="content">
        <div>
          <van-popover
              id="showAreaPopover"
              style="width: 100%"
              v-model="showAreaPopover"
              trigger="click"
              :actions="areas"
              @select="onSelectArea"
          >
          <template #reference>
            <div class="line">
              <div>{{ area }}</div>
              <div>
                <van-icon name="arrow-down"/>
              </div>
            </div>
          </template>
        </van-popover>
        </div>

        <div>
          <van-popover
              class="my-pop"
              style="width: 100%"
              v-model="showAddressPopover"
              trigger="click"
              :actions="addresses"
              @select="onSelectAddress"
          >
            <template #reference>
              <div class="line">
                <div>{{ address }}</div>
                <div>
                  <van-icon name="arrow-down"/>
                </div>
              </div>
            </template>
          </van-popover>
        </div>

      </div>
      <div class="bottom">
        <van-button color="#33bdae" round block type="primary" @click="submit" :disabled="submitAble">
          提交
        </van-button>
      </div>
    </div>
    <van-dialog v-model="showDialog" title="标题" show-cancel-button @confirm="goQuestion">
      <template #title>
        <div style="font-weight: 600">提示</div>
      </template>
      <div class="dialog-content">
        <div class="text">
          请认真确认您选择的区域和地址是否有误，误区请点击 “确认” 按钮，否则请点击 “取消” 按钮！
        </div>
        <div class="dialog-line-content">
          <div class="dialog-line">
            区域：{{ area }}
          </div>
          <div class="dialog-line" style="margin-bottom: 26px;">
            地址：{{ address }}
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "areaSelect",
  data() {
    return {
      loading: true,
      deviceType: sessionStorage.getItem('deviceType'),
      submitAble: true,
      showAreaPopover:false,
      showAddressPopover:false,
      showDialog:false,
      area: "山东省青岛市",
      address: "美年达健康体检中心（银海店）",
      areas: [
/*          { text: '山东省青岛市' },
          { text: '山东省济南市' },
          { text: '北京市' }*/
      ],
      addresses: [
/*          { text: '美年达健康体检中心（银海店）' },
          { text: '某人员医院' },
          { text: '解放军401医院' }*/
      ],
    };
  },
  mounted() {
    this.submitAble = true
    this.getArea()
  },
  methods: {

    /**
     * 加载区域
     * @returns {Promise<void>}
     */
    async getArea() {
      this.loading = true
      let res = await this.$axios.get('/api/user/getH5AreaAndChannel');
      if (res.data) {
        try {
          res.data.areaList.forEach(item => {
            this.areas.push({text: item.label})
          })
          res.data.channelList.forEach(item => {
            this.addresses.push({text: item.label})
          })
          //位置处理
          try {
            this.area = sessionStorage.getItem('area') ? sessionStorage.getItem('area') : this.areas[0].text
            this.address = sessionStorage.getItem('address') ? sessionStorage.getItem('address') : this.addresses[0].text
          } catch (e) {
            console.error("位置处理异常",e );
          }
          this.submitAble = false
          this.loading = false
        } catch (e) {
          this.$notify('区域加载失败');
          console.log("区域加载失败",e );
        }
      } else {
        this.submitAble = true
        this.$notify('区域加载失败');
      }
    },

    /**
     * 提交
     */
    submit(){
      this.showDialog = true
      console.log("提交", );
    },

    goQuestion(){
      this.$router.push({
        path: 'index',
        query: {
          area: this.area,
          address: this.address,
        }
      })
    },

    /**
     * 选择区域
     */
    onSelectArea(action){
      this.area = action.text
    },

    /**
     * 选择地点
     */
    onSelectAddress(action){
      console.log("action",action );
      this.address = action.text
    },
  },
}
</script>
<style>
.van-popover__action {
  width: 100%;
}
</style>
<style scoped>
.area {
  margin: 35% 16px 0px 27px;
}

.loading {
  position: absolute;
  padding-top: 60%;
  padding-left: 40%;
}

.area .title {
  font-size: 18px;
  font-weight: 600;
}

.area .line {
  margin: 30px 20px 0px 0px;
  padding: 6px 10px 6px 10px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: justify;
  justify-content: space-between;
  background: #f9f9f9;
  line-height: 26px;
  font-size: 14px;
}

.area .bottom {
  margin: 16px;
  position: absolute;
  right: 10px;
  left: 10px;
  bottom: 10px;
}

/deep/ .van-dialog__confirm, .van-dialog__confirm:active {
  color: #33c0b2;
}

.dialog-content {
  margin: 9px 12px 10px 12px;
  font-size: 14px;
}

.dialog-content .text {
  margin-bottom: 14px;
  line-height: 22px;
}

.dialog-content .dialog-line {
  line-height: 40px;
  border-bottom: 1px solid;
  border-bottom-color: #e2e2e2;
}

</style>



// WEBPACK FOOTER //
// src/area/areaSelect.vue